import axios from "./axiosInstance";

const customerAPI = {
  
  getDetails: (params) => axios.get("customers", { params }),

  updateStatus: (payload) => axios.post("customers/update-status", payload),

  getQueriesList: (params) => axios.get("customers/queries", { params }),
};

export default customerAPI;